"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.PTextLightType = exports.PTextType = void 0;
var PTextType;
(function (PTextType) {
    PTextType["VALUE"] = "value";
    PTextType["VALUE2"] = "valueV2";
    PTextType["LEAD"] = "lead";
    PTextType["LEAD2"] = "leadV2";
    PTextType["SMALL"] = "small";
    PTextType["XSMALL"] = "xsmall";
})(PTextType = exports.PTextType || (exports.PTextType = {}));
var PTextLightType;
(function (PTextLightType) {
    PTextLightType["LEAD"] = "lead";
    PTextLightType["VALUE"] = "value";
})(PTextLightType = exports.PTextLightType || (exports.PTextLightType = {}));
exports.typography = {
    heading1: {
        fontFamily: 'AralPOS-Regular',
        fontSize: '28px',
        lineHeight: '35px',
        letterSpacing: '1px',
    },
    heading2: {
        fontFamily: 'AralPOS-Regular',
        fontSize: '25px',
        lineHeight: '33px',
        letterSpacing: '0.3px',
    },
    heading3: {
        fontFamily: 'AralPOS-Regular',
        fontSize: '22px',
        lineHeight: '30px',
        letterSpacing: '0.4px',
    },
    heading4: {
        fontFamily: 'AralPOS-Regular',
        fontSize: '20px',
        lineHeight: '27px',
        letterSpacing: '1.2px',
    },
    heading5: {
        fontFamily: 'AralPOS-Regular',
        fontSize: '18px',
        lineHeight: '24px',
        letterSpacing: '1px',
    },
    pText: {
        value: {
            fontFamily: 'Roboto-Regular',
            fontSize: '14px',
            lineHeight: '23px',
            letterSpacing: '0.7px',
        },
        valueV2: {
            fontFamily: 'Roboto-Regular',
            fontSize: '16px',
            lineHeight: '28px',
            letterSpacing: '0.1px',
        },
        lead: {
            fontFamily: 'Roboto-Regular',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.7px',
        },
        leadV2: {
            fontFamily: 'Roboto-Regular',
            fontSize: '18px',
            lineHeight: '32px',
            letterSpacing: '0.15px',
        },
        small: {
            fontFamily: 'Roboto-Regular',
            fontSize: '12px',
            lineHeight: '18px',
            letterSpacing: '0.6px',
        },
        xsmall: {
            fontFamily: 'Roboto-Regular',
            fontSize: '11px',
            lineHeight: '16px',
            letterSpacing: '0.5px',
        },
    },
    pTextLight: {
        value: {
            fontFamily: 'Roboto-Light',
            fontSize: '14px',
            lineHeight: '23px',
            letterSpacing: '0.7px',
        },
        lead: {
            fontFamily: 'Roboto-Light',
            fontSize: '16px',
            lineHeight: '28px',
            letterSpacing: '0.15px',
        },
    },
    label: {
        fontFamily: 'Roboto-Regular',
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.7px',
    },
    helpText: {
        fontFamily: 'Roboto-Regular',
        fontSize: '11px',
        lineHeight: '16px',
        letterSpacing: '0.7px',
    },
    bottomNavText: {
        fontFamily: 'Roboto-Regular',
        fontSize: '10px',
        lineHeight: '16px',
        letterSpacing: '1.8px',
    },
};
